<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-col cols="12" sm="12" md="12" v-if="learner_info" class="">
                <v-row>
                <v-spacer></v-spacer>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model="search"
                        label="Search"                        
                        clearable
                        single-line 
                        hide-details
                        append-icon="mdi-magnify"
                    ></v-text-field>
                </v-col>
                </v-row>
                <div id="my-table-id">
                <div class="scroll">
                    <v-simple-table  dense class="elevation-1" fixed-header height="500px">
                        <thead>
                            <tr>
                                <th class="">Sr. No.</th>
                                <th class="">Registration No.</th>
                                <th class="">Name</th>
                                <th class="">Mobile No.</th>
                                <th class="">Personal Email</th>
                                <th class="">Quota</th>
                                <th class="">Academic Year</th>
                                <th class="">Admission Year</th>
                                <th class="">Standard</th>
                                <th class="">Division</th>
                                <th class="">Fees Concession</th>
                                <th class="">Excess Amount</th>
                                <th class="" v-if="type=='1' || type == '0'">Total Fine Amount</th>
                                <th class="" >No. Of Receipts</th>
                                <th class="" v-if="type=='1' || type == '0'">Installment Details</th>
                                <th class="" v-if="type=='2' || type == '0'">Misc Fee Details</th>
                                <th class="" v-if="type=='3' || type == '0'">Canteen Fee Details</th>
                                <th class="" v-for="header in component_headers" :key="header">
                                    <center>{{ header }}</center>
                                </th>
                            </tr>
                        </thead>
                        <tbody style="overflow-y: scroll;">
                            <tr v-for="s in filteredLearnerInfo" :key="s.id">
                                <td>{{s.sr_no}}</td>
                                <td>{{s.reg_no}}</td>
                                <td>{{s.name}}</td>
                                <td>{{s.primary_contact_number}}</td>
                                <td>{{s.personal_email}}</td>
                                <td>{{s.quota}}</td>
                                <td>{{s.academicyear}}</td>
                                <td>{{s.learner_addmission_year}}</td>
                                <td>{{s.standard}}</td>
                                <td>{{s.div}}</td>
                                <td>{{s.concession}}</td>
                                <td>{{s.excess_amount}}</td>
                                <td v-if="type=='1' || type == '0'">{{s.fine}}</td>
                                <td>{{s.receipts_count}}</td>
                                <td v-if="type=='1' || type == '0'">
                                    <!-- {{s.student_receipts_details}} -->
                                    <span v-if="s.student_receipts_details.length > 0">
                                    <thead>
                                        <tr>
                                            <th>Sr.No.</th>
                                            <th>Date</th>
                                            <th>Receipt No.</th>
                                            <th>Fine</th>
                                            <th>Amount</th>
                                            <th>Remark</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="si in s.student_receipts_details" :key="si.id">
                                            <td>{{si.srno}}</td>
                                            <td>{{si.receipt_date}}</td>
                                            <td>
                                                <v-tooltip top color="warning">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print(si.receipt_no,si.ay,s.reg_no)">
                                                        <v-icon color="warning">mdi-printer</v-icon> {{si.receipt_no}}
                                                    </v-btn>
                                                </template>
                                                <span>
                                                    Print Fee Receipt!!!
                                                </span>
                                            </v-tooltip>
                                            </td>
                                            <td>{{si.fine}}</td>
                                            <td>{{si.amount}}</td>
                                            <td>{{si.remark}}</td>
                                            
                                        </tr>
                                    </tbody>
                                    </span>
                                    <span v-else>
                                        --
                                    </span>
                                </td>
                                <td v-if="type == '2' || type == '0'">
                                    <!-- {{s.student_receipts_details}} -->
                                    <span v-if="s.student_receipts_details_misc.length > 0">
                                    <thead>
                                        <tr>
                                            <th>Sr.No.</th>
                                            <th>Date</th>
                                            <th>Receipt No.</th>
                                            <th>Amount</th>
                                            <th>Remark</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="si in s.student_receipts_details_misc" :key="si.id">
                                            <td>{{si.srno}}</td>
                                            <td>{{si.receipt_date}}</td>
                                            <td>
                                                <v-tooltip top color="warning">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print_misc(si.receipt_no,si.ay,s.reg_no)">
                                                        <v-icon color="warning">mdi-printer</v-icon> {{si.receipt_no}}
                                                    </v-btn>
                                                </template>
                                                <span>
                                                    Print Fee Receipt!!!
                                                </span>
                                            </v-tooltip>
                                            </td>
                                            <td>{{si.amount}}</td>
                                            <td>{{si.remark}}</td>
                                        </tr>
                                    </tbody>
                                    </span>
                                    <span v-else>
                                        --
                                    </span>
                                </td>
                                <td v-if="type == '3' || type == '0'">
                                    <!-- {{s.student_receipts_details}} -->
                                    <span v-if="s.student_receipts_details_canteen.length > 0">
                                    <thead>
                                        <tr>
                                            <th>Sr.No.</th>
                                            <th>Date</th>
                                            <th>Receipt No.</th>
                                            <th>Amount</th>
                                            <th>Remark</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="si in s.student_receipts_details_canteen" :key="si.id">
                                            <td>{{si.srno}}</td>
                                            <td>{{si.receipt_date}}</td>
                                            <td>
                                                <v-tooltip top color="warning">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print_canteen(si.receipt_no,si.ay)">
                                                        <v-icon color="warning">mdi-printer</v-icon> {{si.receipt_no}}
                                                    </v-btn>
                                                </template>
                                                <span>
                                                    Print Fee Receipt!!!
                                                </span>
                                            </v-tooltip>
                                            </td>
                                            <td>{{si.amount}}</td>
                                            <td>{{si.remark}}</td>
                                        </tr>
                                    </tbody>
                                    </span>
                                    <span v-else>
                                        --
                                    </span>
                                </td>
                                <td v-for="(header,index) in s.all_comp" :key="index">
                                    <span v-if="header == 'Not Applicable'" class="text-color">
                                        {{header}}
                                    </span>
                                    <span v-else>
                                         {{header}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                </div>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
          props: {
            learner_info: Array,
            component_headers: Array,
            type:String
        },
        data() {
            
            return {
                loader: false,
                color: "",
                snackbar: false,
                search: "",
                snackbar_msg: null,
                fees_structure_data: null,
                current_academic_year: null,
                stream: null,
                div: null,
                std: "",
                header: null,
                academic_year_list: null,
                standard_list: null,
                dision_list: null,
                stream_list: null,
                header_list: null,
                show: false,
              //  learner_info: [],
                data_list: [],
              //  component_headers: [],
                all_total_amount:null,
                all_total_paid:null,
                all_total_remaining:null,
                org:null,
            };
        },
        computed: {
            filteredLearnerInfo() {
            return this.learner_info.filter((item) => {
                // console.log("learner info: "+JSON.stringify( this.learner_info));
            const reg_no = item.reg_no ? item.reg_no.toLowerCase() : '';
            const name = item.name ? item.name.toLowerCase() : '';
            const primary_contact_number = item.primary_contact_number ? item.primary_contact_number.toLowerCase() : '';
            const personal_email = item.personal_email ? item.personal_email.toLowerCase() : '';
            const quota = item.quota ? item.quota.toLowerCase() : '';
            const academicyear = item.academicyear ? item.academicyear.toLowerCase() : '';            
            const searchTerm = this.search.toLowerCase();
            
                return (
                    reg_no.toLowerCase().includes(searchTerm)  ||
                    name.toLowerCase().includes(searchTerm)  ||
                    primary_contact_number.toLowerCase().includes(searchTerm)  ||
                    personal_email.toLowerCase().includes(searchTerm)  ||
                    quota.toLowerCase().includes(searchTerm)  ||
                    academicyear.toLowerCase().includes(searchTerm)                      
                );
            });
            },
        },
        methods: {
             print(receipt_no, ay, registration_number) {
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(registration_number));
                if (this.org_id == "zeal") {
                    let routeData = this.$router.resolve({ name: "zeal-student-receipt" });
                    window.open(routeData.href, "_blank");
                } else if (this.org_id == "wws") {
                    let routeData = this.$router.resolve({ name: "student-fees-receipts-wws" });
                    window.open(routeData.href, "_blank");
                } else if (this.org_id == "uwws") {
                    let routeData = this.$router.resolve({ name: "student-fees-receipts-uwws" });
                    window.open(routeData.href, "_blank");
                } else if (this.org_id == "sanjivani") {
                    let routeData = this.$router.resolve({ name: "student-fees-receipts-sanjivani" });
                    window.open(routeData.href, "_blank");
                } else {
                    let routeData = this.$router.resolve({ name: "student-fees-receipts" });
                    window.open(routeData.href, "_blank");
                }
             },
             print_misc(receipt_no, ay, registration_number){
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(registration_number));
                let routeData = this.$router.resolve({
                    name: "misc-other-exam-fees-payment-receipt",
                });
                window.open(routeData.href, "_blank");
             },
             print_canteen(receipt_no, ay){
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                let routeData = this.$router.resolve({ name: "canteen-receipt" });
                window.open(routeData.href, "_blank");
             },
             fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';
                tab_text = tab_text + '<x:Name>Test Sheet</x:Name>';
                tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
                tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $('#' + id).clone();
                exportTable.find('input').each(function (index, elem) { $(elem).remove(); });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + '</table></body></html>';
                var fileName = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

                //Save the file
                // var blob = new Blob([tab_text], { type: "application/vnd.ms-excel;charset=utf-8" })
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
                },
            ExportToExcel(){
            var htmltable= document.getElementById('my-table-id');
            var html = htmltable.outerHTML;
            window.open('data:application/vnd.ms-excel,' + encodeURIComponent(html));
            },
            clear() {
                this.learner_info = [];
                this.data_list = [];
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
        },
    };
</script>
<style scoped>
    .scroll {
        overflow-x: scroll;
    }
    .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .dt-button {
        font-size: small;
        font-weight: bold;
    }
    .dt-button.buttons-print::before {
        content: "\F42A";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-excel::before {
        content: "\F21B";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-csv::before {
        content: "\FEC2";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    button.dt-button:hover:not(.disabled),
    div.dt-button:hover:not(.disabled),
    a.dt-button:hover:not(.disabled) {
        border-color: #ff9800;
        color: #ff9800;
    }
    .dataTables_wrapper .dataTables_filter input[type="search"] {
        border-radius: 2px;
        border: 1px solid #cdcdcd;
        cursor: auto;
        white-space: nowrap !important;
    }
</style>
